var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Товари та матеріали","resource":"sales-products","columns":_vm.columns,"get-items-fn":_vm.getProducts}})}
var staticRenderFns = []

export { render, staticRenderFns }